lockScreenOrientation()
// Lock the screen orientation to portrait mode
function lockScreenOrientation() {
  if (screen.orientation && screen.orientation.lock) {
    screen.orientation.lock('portrait').catch(function() {
      // Handle error
    });
  } else if (screen.lockOrientation) {
    screen.lockOrientation('portrait');
  } else {
    // Orientation API not supported
  }
}
